var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshIcon = function SvgRefreshIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "currentColor",
    viewBox: "0 0 15 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.269 12.5c3.057 0 5.534-2.462 5.534-5.5h1.51c0 3.866-3.154 7-7.044 7S.225 10.866.225 7 3.38 0 7.27 0a7.05 7.05 0 0 1 5.534 2.67V.01h1.51v5H9.28v-1.5h2.266A5.54 5.54 0 0 0 7.269 1.5C4.212 1.5 1.735 3.962 1.735 7s2.477 5.5 5.534 5.5",
    clipRule: "evenodd"
  })));
};
export default SvgRefreshIcon;